export const GALLERIES_PATH = (id: any) => `/libraries/${id}`
export const GALLERY_DELETE_IMAGE_PATH = '/s3'
export const GALLERY_SLICED_OFFSET = 40
